/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApplicationUserFromJSON, ApplicationUserToJSON, CarFromJSON, CarToJSON, CustomerFromJSON, CustomerToJSON, ProtocolFromJSON, ProtocolToJSON, } from './';
export function ReservationFromJSON(json) {
    return ReservationFromJSONTyped(json, false);
}
export function ReservationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : ApplicationUserFromJSON(json['createdBy']),
        'createdById': !exists(json, 'createdById') ? undefined : json['createdById'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : ApplicationUserFromJSON(json['modifiedBy']),
        'modifiedById': !exists(json, 'modifiedById') ? undefined : json['modifiedById'],
        'customer': !exists(json, 'customer') ? undefined : CustomerFromJSON(json['customer']),
        'customerId': !exists(json, 'customerId') ? undefined : json['customerId'],
        'carId': !exists(json, 'carId') ? undefined : json['carId'],
        'car': !exists(json, 'car') ? undefined : CarFromJSON(json['car']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'begins': !exists(json, 'begins') ? undefined : (new Date(json['begins'])),
        'ends': !exists(json, 'ends') ? undefined : (new Date(json['ends'])),
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'protocolDeliverId': !exists(json, 'protocolDeliverId') ? undefined : json['protocolDeliverId'],
        'protocolDeliver': !exists(json, 'protocolDeliver') ? undefined : ProtocolFromJSON(json['protocolDeliver']),
        'protocolReturnId': !exists(json, 'protocolReturnId') ? undefined : json['protocolReturnId'],
        'protocolReturn': !exists(json, 'protocolReturn') ? undefined : ProtocolFromJSON(json['protocolReturn']),
    };
}
export function ReservationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdBy': ApplicationUserToJSON(value.createdBy),
        'modifiedBy': ApplicationUserToJSON(value.modifiedBy),
        'customer': CustomerToJSON(value.customer),
        'customerId': value.customerId,
        'carId': value.carId,
        'car': CarToJSON(value.car),
        'description': value.description,
        'begins': value.begins === undefined ? undefined : (value.begins.toISOString()),
        'ends': value.ends === undefined ? undefined : (value.ends.toISOString()),
        'isDeleted': value.isDeleted,
        'protocolDeliverId': value.protocolDeliverId,
        'protocolDeliver': ProtocolToJSON(value.protocolDeliver),
        'protocolReturnId': value.protocolReturnId,
        'protocolReturn': ProtocolToJSON(value.protocolReturn),
    };
}
